import React from "react";
import PropTypes from "prop-types";
import { ToastContainer } from "react-toastify";
import { ThemeProvider } from "emotion-theming";
import { AuthProvider } from "modules/auth";
import styled from "@emotion/styled";
import ErrorBoundary from "components/ErrorBoundary";
import Navbar from "components/NavbarNew";
import Footer from "components/FooterNew";
import SponsorFooter from "components/SponsorFooter";
import ErrorPage from "components/ErrorPage";
import Colors from "utils/themes";
import "styles/index.scss";

import "react-toastify/dist/ReactToastify.css";
import { connect } from "react-redux";
import { getAuthUser, shortnameSelector } from "modules/session/selectors";

const AppContainer = styled.div`
  overflow-x: hidden;
  background-color: ${props => props.theme.colors.background};
`;

const Layout = ({ children, theme, user, shortName, hidden }) => (
  <ThemeProvider theme={theme}>
    <AuthProvider user={user && { ...user, shortName }}>
      <AppContainer>
        <Navbar />
        <ErrorBoundary errorComponent={ErrorPage}>{children}</ErrorBoundary>
        {!hidden && <SponsorFooter />}
        <Footer />
        <ToastContainer
          toastClassName="toast-container"
          bodyClassName="toast-body"
          position="bottom-center"
          hideProgressBar={true}
          autoClose={2000}
        />
      </AppContainer>
    </AuthProvider>
  </ThemeProvider>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  theme: PropTypes.shape({}).isRequired,
};

Layout.defaultProps = {
  theme: Colors,
};

export default connect(state => ({
  user: getAuthUser(state),
  shortName: shortnameSelector(state),
}))(Layout);
